import React, { useState } from "react";
import { makeStyles, Box, Container, Tabs, Tab } from "@material-ui/core";
import Page from "../components/Page";
import RegisterContainer from "../containers/auth/RegisterContainer";
import FooterView from "../views/auth/FooterView";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const TYPES = ["installer", "customer"];

const RegisterPage = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { type: typeParam } = useParams();
  const [type, setType] = useState(
    TYPES.includes(typeParam) ? typeParam : "installer"
  );

  return (
    <Page className={classes.root} title="Ecat">
      <Box display="flex" flexDirection="column" justifyContent="center">
        <Container maxWidth="sm">
          <Tabs
            value={type}
            onChange={(_, value) => setType(value)}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Tab label={t("register.tabs.customer")} value="customer" />
            <Tab label={t("register.tabs.installer")} value="installer" />
          </Tabs>
          <RegisterContainer type={type} />
          <FooterView type={type} login={true} reset={true} />
        </Container>
      </Box>
    </Page>
  );
};

export default RegisterPage;
